import { render } from "./PostBreadCrumbV2Cmp.vue?vue&type=template&id=3a92e5fc"
import script from "./PostBreadCrumbV2Cmp.vue?vue&type=script&lang=js"
export * from "./PostBreadCrumbV2Cmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__